module.exports = __webpack_public_path__ + "img/poster-mobile.0bd16af9.png";